const VOCAL_TASK_LABELS = Object.freeze({
  sustainedVowel: "Sustained vowel",
  sustainedVowelA: "Sustained vowel /a/",
  sustainedVowelE: "Sustained vowel /e/",
  sustainedVowelI: "Sustained vowel /i/",
  sustainedVowelO: "Sustained vowel /o/",
  sustainedVowelU: "Sustained vowel /u/",
  readCAPEVSentences: "CAPE-V sentences",
  readCAPEVrSentences: "CAPE-Vr sentences",
  otherReadSentences: "Other read sentences",
  readingPassage: "Reading passage",
  extemporaneousSpeech: "Extemporaneous speech",
  singingVoice: "Singing voice",
  customTask: "Custom task",
});

export function vocalTaskLabel(task) {
  return VOCAL_TASK_LABELS[task] || String(task).replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, value => value.toUpperCase());
}

export function presentVocalTasks(tasks = []) {
  const unique = [...new Set(tasks.filter(Boolean))];
  const hasSpecificVowel = unique.some(task => /^sustainedVowel[AEIOU]$/.test(task));
  return unique.filter(task => !(task === "sustainedVowel" && hasSpecificVowel)).map(vocalTaskLabel);
}
